import { Tabs, Tab } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type PropsType = {
    heightFull?: boolean
}
export default function HeadersTab({ heightFull = false }: PropsType) {
    const [tab, setTab] = useState("/")
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleChangeTab = (newValue: string) => () => {
        setTab(newValue);
        navigate(newValue);
    }
    return (
        <Tabs
            TabIndicatorProps={{
                sx: {
                    backgroundColor: 'transparent',
                    borderBottom: '2px dashed',
                    borderColor: "primary.contrastText",
                },
            }}
            className={`bg-primary-main text-primary-contrastText ${heightFull ? 'h-full' : ''}`}
            textColor="inherit"
            indicatorColor="secondary"
            value={tab}
            centered>
            <Tab onClick={handleChangeTab('/')} value='/' label={t('home')} />
            <Tab onClick={handleChangeTab('/car/new')} value='/car/new' label={t('submit_car')} />
            <Tab value='/report' label={t('reports')} />
        </Tabs>
    )
}
